import { cloneElement } from 'react';
import { useLabelMask } from './useLabelMask';
import { getOnlyChild } from './maskHelpers';
import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const LabelMask = props => {
  const field = getOnlyChild(props.children);
  const {
    labelMask,
    inputProps
  } = useLabelMask(props.labelMask, field.props);
  const input = /*#__PURE__*/cloneElement(field, inputProps);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [labelMask, input]
  });
};
export default LabelMask;